import React from 'react';

export default function AccessiTable(props) {
  return (
    <div className='row'>
      {/* className='table table-striped table-bordered table-hover' */}
      <div className='col-lg-12  mx-auto   rounded shadow  '>
        <div className='table-responsive table-hover table-striped'>
          <table className='table table-fixed table-hover table-striped'>
            <thead className='table table-striped table-bordered table-hover'>
              <tr>
                <th scope='col' className='col-1'>
                  Id
                </th>
                <th scope='col' className='col-1'>
                  Accessi
                </th>
                <th scope='col' className='col-4'>
                  Descrizione
                </th>
                <th scope='col' className='col-1'>
                  Open
                </th>
                <th scope='col' className='col-1'>
                  Close
                </th>
                <th scope='col' className='col-4'>
                  Data{' '}
                </th>
                {/* <th scope='col' className='col-1'>
                  zz
                </th>

                <th scope='col' className='col-1'></th>
                <th scope='col' className='col-1'></th> */}
              </tr>
            </thead>
            <tbody>
              {props.accessi.map((accessi, k) => (
                <tr key={k}>
                  <td className='col-1'>{k}</td>
                  <td className='col-1'>{accessi.id}</td>
                  <td className='col-4'>{accessi.descrizione}</td>
                  <td className='col-1'>{accessi.opend}</td>
                  <td className='col-1'>{accessi.closed}</td>

                  <td className='col-4'>{accessi.datar}</td>

                  {/* <td className='col-1'>{'ll'}</td> */}
                  {/* <td className='col-1'>
                    <button
                      className='btn btn-warning table-buttons'
                      // onClick={() => this.modifica(cliente.id, k)}
                    >
                      <i className='fa fa-edit' aria-hidden='true'></i> Modifica
                    </button>
                  </td>
                  <td className='col-1'>
                    <button
                      className='btn btn-warning table-buttons'
                      //onClick={() => this.Elimina(k)}
                      //onClick={() => this.Elimina(k)}

                      //per passare un parametro bisogna creare una arrowfunc
                      //cosi non viene eseguita in fase di render
                    >
                      <i className='fa fa-minus' aria-hidden='true'></i> Elimina
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
